import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, LoadingController, AlertController } from 'ionic-angular';
import { ServiceApiProvider } from '../../providers/service-api/service-api';
import { B02D02RefundListPage } from '../b02-d02-refund-list/b02-d02-refund-list';

/**
 * Generated class for the B02RefundPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

interface soInfo{
  SO_ID: number;
  SO_NO: string;
  CARD: string;
  DATETIME: string;
  GRAND_TOTAL: number; 
  ACTION_BY: number;

  BRANCH_ID: number;
  BRANCH_NAME: string;
  EMAIL: string;
  ADDR1: string;
  
  USER_ID: number;
  USER_NAME: string;

  SO_STATUS_ID: number;
  STATUS: string;
}

interface branchInfo{
  BRANCH_ID: number;
  BRANCH_NAME: string;
}
interface userInfo{
  USER_ID: number;
  USER_NAME: string;
}

@IonicPage()
@Component({
  selector: 'page-b02-refund',
  templateUrl: 'b02-refund.html',
})
export class B02RefundPage {

  loading: any;
  Status: any;
  soArr: soInfo[] = [];
  soArr2: soInfo[] = [];
  soItems: soInfo[] = [];
  branchArr: branchInfo[] = [];
  branchItems: branchInfo[] = [];
  userArr: userInfo[] = [];
  userItems: userInfo[] = [];
  public errorMessage: any = "";

  GRP_ID: any;
  public BRANCH_ID: any;
  soNumber: any = '';
  first_time:any;
  public USER_ID: any;
  dateStart:any = '';
  dateEnd: any = '';

  constructor(public navCtrl: NavController, public navParams: NavParams, public alertCtrl : AlertController,
              public serviceapi: ServiceApiProvider, public loadingCtrl: LoadingController) {


    this.GRP_ID = sessionStorage.getItem('usergroupid');
    this.BRANCH_ID = sessionStorage.getItem('userbranchid');

    if (this.GRP_ID == "1") {
      let tbl = ["All"];
      let column = ["All"];
      let value = ["All"];
      
      let tblkey = ["No"];
      let fktbl = ["No"];
      let fkkey = ["No"];
    
      let jsonitem = this.serviceapi.requestitem(tbl,column,value,tblkey,fktbl,fkkey);

      let mydata = Object.assign(jsonitem);
      let json_data = this.serviceapi.json_readdata(mydata,"1");

      this.serviceapi.readdata(json_data,"BRANCH","1","1").then((result) => {
        this.Status = result["Message"];
        if (this.Status == '1'){
          
          let Records = result["Records"];
          this.branchArr = Records;
          this.branchItems = this.branchArr;

          this.BRANCH_ID = this.branchArr[0].BRANCH_ID;
          this.soData();
        }
        else {
          this.errorMessage = this.serviceapi.displayErrorMessage(this.Status);
        }
      }, (err) => {
        this.errorMessage = "Branch Info Loading Error. Please try again. Error Code: '" + err + "'";

      });
    }
    else {
      this.soData();
    }

    
    
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad B02RefundPage');
  }

  soData(){

    let tbl = ["USER"];
    let column = ["BRANCH_ID"];
    let value = [this.BRANCH_ID];
    
    let tblkey = ["No"];
    let fktbl = ["No"];
    let fkkey = ["No"];

    let jsonitem = this.serviceapi.requestitem(tbl,column,value,tblkey,fktbl,fkkey);
    let mydata = Object.assign(jsonitem);
    let json_data = this.serviceapi.json_readdata(mydata,"1");
    this.showLoader();
    console.log(json_data);
    this.serviceapi.readdata(json_data,"USER","1","1").then((result) => {
        
      this.Status = result["Message"];
      console.log(result["Records"]);
      if (this.Status == "1"){
        let Records = result["Records"];
        this.userArr = Records;
        this.userItems = this.userArr;

        this.USER_ID = 'All';

        let sortby= "DATETIME";
        let sorttype= "DESC";

        let tbl = ["SO", "SO"];
        let column = ["SO_STATUS_ID", "BRANCH_ID"];
        let value = ["1", this.BRANCH_ID];                                //successful
        
        let tblkey = ["SO_STATUS_ID","BRANCH_ID", "ACTION_BY"];
        let fktbl = ["SO_STATUS","BRANCH", "USER"];
        let fkkey = ["SO_STATUS_ID","BRANCH_ID", "USER_ID"];
      
        let jsonsort = this.serviceapi.sort(sortby,sorttype);
        let jsonitem = this.serviceapi.requestitem(tbl,column,value,tblkey,fktbl,fkkey);

        let mydata = Object.assign(jsonsort,jsonitem);
        let json_data = this.serviceapi.json_readdata(mydata,"1");
        //this.showLoader();
        
        
        this.serviceapi.readdata(json_data,"SO","1","1").then((result) => {
          this.loading.dismiss();
          this.Status = result["Message"];
          if (this.Status == '1'){
            let Records = result["Records"];
            this.soArr = Records;
            this.soItems = this.soArr;
          
            console.log(this.soItems);
          }
          else {
            this.errorMessage = this.serviceapi.displayErrorMessage(this.Status);
          }

        }, (err) => {
          this.errorMessage = "Loading Error. Please try again. Error Code: '" + err + "'";
          this.loading.dismiss();
        });
      }
      else {
        this.errorMessage = this.serviceapi.displayErrorMessage(this.Status);
        this.loading.dismiss();
      }

    }, (err) => {
      this.errorMessage = "Loading Error. Please try again. Error Code: '" + err + "'";
      this.loading.dismiss();
    });
    
  }

  showLoader(){
    this.loading = this.loadingCtrl.create({
        content: 'Loading...',
        duration: 5000,
    });
    this.loading.present();
  }

  goToManage(ID){
    this.navCtrl.push(B02D02RefundListPage, {paramID: ID});       //so ID
  }

  searchItem(){
    console.log(this.BRANCH_ID, this.USER_ID);
    console.log(this.dateStart, this.dateEnd);

    if (this.soNumber == ''){                                           //no SO
      if (this.USER_ID == 'All'){                                       //All user for all
        if (this.dateStart=='' && this.dateEnd=='') {                   //All date
          console.log("With All User All date");

          this.errorMessage="";
          this.soItems = [];
      
          let sortby= "DATETIME";
          let sorttype= "DESC";
      
          let tbl = ["SO", "SO"];
          let column = ["SO_STATUS_ID", "BRANCH_ID"];
          let value = ["1", this.BRANCH_ID];                                //successful
          
          let tblkey = ["SO_STATUS_ID","BRANCH_ID", "ACTION_BY"];
          let fktbl = ["SO_STATUS","BRANCH", "USER"];
          let fkkey = ["SO_STATUS_ID","BRANCH_ID", "USER_ID"];

          let start = [""];
          let end = [""];
          let col = ["DATETIME"];
          let table = ["SO"];
        
          let jsonsort = this.serviceapi.sort(sortby,sorttype);
          let jsonitem = this.serviceapi.requestitem(tbl,column,value,tblkey,fktbl,fkkey);
  //        let jsonrange = this.serviceapi.range(start,end,col,table);
      
          let mydata = Object.assign(jsonsort,jsonitem);
          let json_data = this.serviceapi.json_readdata(mydata,"1");
          this.showLoader();
          
          console.log(json_data);
          this.serviceapi.readdata(json_data,"SO","1","1").then((result) => {
            this.loading.dismiss();
            this.Status = result["Message"];
            if (this.Status == '1'){
              let Records = result["Records"];
              this.soArr = Records;
              this.soItems = this.soArr;
            
              console.log(this.soItems);
            }
            else {
              this.errorMessage = this.serviceapi.displayErrorMessage(this.Status);
            }
      
          }, (err) => {
            this.errorMessage = "Loading Error. Please try again. Error Code: '" + err + "'";
            this.loading.dismiss();
          });
        }
        else if (this.dateStart!='' && this.dateEnd!='') {                   //Selected date
          console.log("With All User selected date");

          this.errorMessage="";
          this.soItems = [];
      
          let sortby= "DATETIME";
          let sorttype= "DESC";
      
          let tbl = ["SO", "SO"];
          let column = ["SO_STATUS_ID", "BRANCH_ID"];
          let value = ["1", this.BRANCH_ID];                                //successful
          
          let tblkey = ["SO_STATUS_ID","BRANCH_ID", "ACTION_BY"];
          let fktbl = ["SO_STATUS","BRANCH", "USER"];
          let fkkey = ["SO_STATUS_ID","BRANCH_ID", "USER_ID"];

          let start = this.dateStart;
          let end = this.dateEnd;
          let col = "DATETIME";
          let table = "SO";
        
          let jsonsort = this.serviceapi.sort(sortby,sorttype);
          let jsonitem = this.serviceapi.requestitem(tbl,column,value,tblkey,fktbl,fkkey);
          let jsonrange = this.serviceapi.rangesearch(start,end,col,table);

          let mydata = Object.assign(jsonsort,jsonitem,jsonrange);
          let json_data = this.serviceapi.json_readdata(mydata,"1");
          this.showLoader();
          
          console.log(json_data);
          this.serviceapi.readdata(json_data,"SO","1","1").then((result) => {
            this.loading.dismiss();
            this.Status = result["Message"];
            if (this.Status == '1'){
              let Records = result["Records"];
              this.soArr = Records;
              this.soItems = this.soArr;
            
              console.log(this.soItems);
            }
            else {
              this.errorMessage = this.serviceapi.displayErrorMessage(this.Status);
            }
      
          }, (err) => {
            this.errorMessage = "Loading Error. Please try again. Error Code: '" + err + "'";
            this.loading.dismiss();
          });
        }
        else{
          let addToDoAlert = this.alertCtrl.create({
            title:"Alert",
            message:"Please complete transaction date range.",
            buttons:[
              {
                text:"OK"
              }]
          });
          addToDoAlert.present();
        }
      }
      else {                                                                            //select user
        if (this.dateStart=='' && this.dateEnd=='') {                   //All date
          console.log("With User ID All date");

          this.errorMessage="";
          this.soItems = [];
      
          let sortby= "DATETIME";
          let sorttype= "DESC";
      
          let tbl = ["SO", "SO", "SO"];
          let column = ["SO_STATUS_ID", "BRANCH_ID", "ACTION_BY"];
          let value = ["1", this.BRANCH_ID, this.USER_ID];                                //successful
          
          let tblkey = ["SO_STATUS_ID","BRANCH_ID", "ACTION_BY"];
          let fktbl = ["SO_STATUS","BRANCH", "USER"];
          let fkkey = ["SO_STATUS_ID","BRANCH_ID", "USER_ID"];
        
          let jsonsort = this.serviceapi.sort(sortby,sorttype);
          let jsonitem = this.serviceapi.requestitem(tbl,column,value,tblkey,fktbl,fkkey);
      
          let mydata = Object.assign(jsonsort,jsonitem);
          let json_data = this.serviceapi.json_readdata(mydata,"1");
          this.showLoader();
          
          console.log(json_data);
          this.serviceapi.readdata(json_data,"SO","1","1").then((result) => {
            this.loading.dismiss();
            this.Status = result["Message"];
            if (this.Status == '1'){
              let Records = result["Records"];
              this.soArr = Records;
              this.soItems = this.soArr;
            
              console.log(this.soItems);
            }
            else {
              this.errorMessage = this.serviceapi.displayErrorMessage(this.Status);
            }
      
          }, (err) => {
            this.errorMessage = "Loading Error. Please try again. Error Code: '" + err + "'";
            this.loading.dismiss();
          });
        }
        else if (this.dateStart!='' && this.dateEnd!='') {                   //Selected date
          console.log("With User ID All date");

          this.errorMessage="";
          this.soItems = [];
      
          let sortby= "DATETIME";
          let sorttype= "DESC";
      
          let tbl = ["SO", "SO", "SO"];
          let column = ["SO_STATUS_ID", "BRANCH_ID", "ACTION_BY"];
          let value = ["1", this.BRANCH_ID, this.USER_ID];                                //successful
          
          let tblkey = ["SO_STATUS_ID","BRANCH_ID", "ACTION_BY"];
          let fktbl = ["SO_STATUS","BRANCH", "USER"];
          let fkkey = ["SO_STATUS_ID","BRANCH_ID", "USER_ID"];
        
          let start = this.dateStart;
          let end = this.dateEnd;
          let col = "DATETIME";
          let table = "SO";
        
          let jsonsort = this.serviceapi.sort(sortby,sorttype);
          let jsonitem = this.serviceapi.requestitem(tbl,column,value,tblkey,fktbl,fkkey);
          let jsonrange = this.serviceapi.rangesearch(start,end,col,table);

          let mydata = Object.assign(jsonsort,jsonitem,jsonrange);
          let json_data = this.serviceapi.json_readdata(mydata,"1");
          this.showLoader();
          
          console.log(json_data);
          this.serviceapi.readdata(json_data,"SO","1","1").then((result) => {
            this.loading.dismiss();
            this.Status = result["Message"];
            if (this.Status == '1'){
              let Records = result["Records"];
              this.soArr = Records;
              this.soItems = this.soArr;
            
              console.log(this.soItems);
            }
            else {
              this.errorMessage = this.serviceapi.displayErrorMessage(this.Status);
            }
      
          }, (err) => {
            this.errorMessage = "Loading Error. Please try again. Error Code: '" + err + "'";
            this.loading.dismiss();
          });
        }
        else{
          let addToDoAlert = this.alertCtrl.create({
            title:"Alert",
            message:"Please complete transaction date range.",
            buttons:[
              {
                text:"OK"
              }]
          });
          addToDoAlert.present();
        }
      }
    }
    else{                                                         //with SO number
      this.errorMessage="";
      this.soItems = [];
  
      let sortby= "DATETIME";
      let sorttype= "DESC";
  
      let tbl = ["SO", "SO"];
      let column = ["SO_STATUS_ID", "SO_NO"];
      let value = ["1", this.soNumber];                                //successful
      
      let tblkey = ["SO_STATUS_ID","BRANCH_ID", "ACTION_BY"];
      let fktbl = ["SO_STATUS","BRANCH", "USER"];
      let fkkey = ["SO_STATUS_ID","BRANCH_ID", "USER_ID"];
    
      let jsonsort = this.serviceapi.sort(sortby,sorttype);
      let jsonitem = this.serviceapi.requestitem(tbl,column,value,tblkey,fktbl,fkkey);
  
      let mydata = Object.assign(jsonsort,jsonitem);
      let json_data = this.serviceapi.json_readdata(mydata,"1");
      this.showLoader();
      
      console.log(json_data);
      this.serviceapi.readdata(json_data,"SO","1","1").then((result) => {
        this.loading.dismiss();
        this.Status = result["Message"];
        if (this.Status == '1'){
          let Records = result["Records"];
          this.soArr = Records;
          this.soItems = this.soArr;
        
          console.log(this.soItems);
        }
        else {
          this.errorMessage = this.serviceapi.displayErrorMessage(this.Status);
        }
  
      }, (err) => {
        this.errorMessage = "Loading Error. Please try again. Error Code: '" + err + "'";
        this.loading.dismiss();
      });
    }
    
  }

  clearItem(){
    this.soNumber = "";
    this.dateStart = "";
    this.dateEnd = "";
  }

  onChange(BRANCH_ID){
    this.BRANCH_ID = BRANCH_ID;
    this.userArr=[];
    this.userItems=[];
    console.log(BRANCH_ID);

    let tbl = ["USER"];
    let column = ["BRANCH_ID"];
    let value = [BRANCH_ID];
    
    let tblkey = ["No"];
    let fktbl = ["No"];
    let fkkey = ["No"];

    let jsonitem = this.serviceapi.requestitem(tbl,column,value,tblkey,fktbl,fkkey);
    let mydata = Object.assign(jsonitem);
    let json_data = this.serviceapi.json_readdata(mydata,"1");
    console.log(json_data);
    this.serviceapi.readdata(json_data,"USER","1","1").then((result) => {

      this.Status = result["Message"];
      console.log(result["Records"]);
      if (this.Status == "1"){
        let Records = result["Records"];
        this.userArr = Records;
        this.userItems = this.userArr;

        this.USER_ID = 'All';
      }
      else {
        this.errorMessage = this.serviceapi.displayErrorMessage(this.Status);
      }

    }, (err) => {
      this.errorMessage = "Loading Error. Please try again. Error Code: '" + err + "'";

    });
  }
  
}



// WEBPACK FOOTER //
// ./src/pages/b02-refund/b02-refund.ts